import React from 'react';
import { Heading } from '../../../typography/heading/Heading';
import PromotinalTag from '../../../atoms/promotinalTag/PromotinalTag';
import DiscountTag from '../../../atoms/discountTag/DiscountTag';
import PromoMessage from '../../../atoms/promoMessage/PromoMessage';
import styles from '../ProductActions.module.scss';

interface PromoMessageType {
  name: string;
  [key: string]: any;
}

interface HeaderActionProps {
  title?: string;
  priceSection: React.ReactNode;
  discount?: Record<string, any>;
  discountedPrice?: number;
  price?: number;
  text?: string;
  renderTextLink: (className: string) => React.ReactNode;
  promoMessage?: PromoMessageType;
}

const HeaderAction: React.FC<HeaderActionProps> = ({
  title,
  priceSection,
  discount,
  discountedPrice,
  price,
  text,
  renderTextLink,
  promoMessage,
}) => {
  return (
    <div className={styles.headerWrapper}>
      {title ? (
        <Heading className={styles.mainHeading} placement="pdp" as="h1">
          {title}
        </Heading>
      ) : null}
      {priceSection}
      {discount?.name ? (
        <PromotinalTag data={discount} placement="pdp" />
      ) : discountedPrice ? (
        <DiscountTag
          fullPrice={price}
          discountPrice={discountedPrice}
          customStyles={styles.discountTag}
        />
      ) : null}
      {!!promoMessage && promoMessage.name && <PromotinalTag data={promoMessage} isFromFrontastic />}
      {/*@ts-ignore*/}
      {text && <PromoMessage className={styles.promoMessage} text={text} />}
      {renderTextLink(styles.linkMobile)}
    </div>
  );
};

export default HeaderAction;
